import type { TSkeletons } from '@frontend/pole-ui/lib/components/Skeleton'
import type { IDocumentContentParams } from '@/logic/legalDocuments/interfaces'

export const legalDocumentsSkeletons: TSkeletons = [{ height: '100vh', styleName: 'whiteGray' }]

export const WORKING_CONDITIONS_DOCUMENT_PARAMETERS: Readonly<IDocumentContentParams> = {
  documentId: 'COMPANY',
  versionId: 'TRUD',
}
